import React from 'react';
import { ERouteLinks } from 'models/route';
import { useTranslations } from 'hooks/useTranslations';
import { usePermission } from 'hooks/usePermission';
import { EPermission } from 'models/permissions';
import { EIconTypes } from 'constants/Icons';
import ElementsComponent, { IElements } from './elementsComponent';

const LicencesModule = () => {
  const { t } = useTranslations();
  const { hasPermissions } = usePermission();
  const elements: IElements[] = [];
  if (hasPermissions([EPermission.MANAGE_SETTINGS])) {
    elements.push({
      url: ERouteLinks.GeneralLicenceSettings,
      title: t('generalSettings.header'),
    });
  }
  if (hasPermissions([EPermission.MANAGE_LICENCE_AUTHORITY])) {
    elements.push({
      url: ERouteLinks.LicenceAuthorities,
      title: t('licenceAuthorities.header'),
    });
  }
  if (hasPermissions([EPermission.MANAGE_WEAPON_LICENCE_CONFIGURATOR])) {
    elements.push({
      url: ERouteLinks.LicenceConfigurationPage,
      title: t('licenceConfiguration.header'),
    });
  }

  return (
    <ElementsComponent
      title={t('licencesModule.header')}
      iconType={EIconTypes.licencesModule}
      elements={elements}
    />
  );
};

export default LicencesModule;
